// Archivio Case History: filtro PER CHI in pagina (mostra/nascondi le card in base
// allo slug della destinazione). AMBIENTE sono link agli archivi termine (non qui).
const archivioCasehistory = () => {
  document.querySelectorAll(".archivio-casehistory").forEach((section) => {
    // Solo i bottoni PER CHI hanno data-filter; AMBIENTE sono <a> senza data-filter.
    const pills = section.querySelectorAll(".archivio-casehistory__pill[data-filter]");
    const cols = Array.from(section.querySelectorAll(".archivio-casehistory__col"));
    if (!pills.length || !cols.length) return;

    pills.forEach((pill) => {
      pill.addEventListener("click", () => {
        const value = pill.dataset.filter;

        pills.forEach((p) => {
          const on = p === pill;
          p.classList.toggle("is-active", on);
          p.setAttribute("aria-pressed", String(on));
        });

        cols.forEach((col) => {
          const slugs = (col.dataset.destinazione || "").split(" ").filter(Boolean);
          const show = value === "*" || slugs.includes(value);
          col.classList.toggle("is-hidden", !show);
        });
      });
    });
  });
};

export default archivioCasehistory;
